import { DocumentSnapshot, QueryDocumentSnapshot } from "firebase/firestore";

export default function cleanFirestoreDoc(
  doc: DocumentSnapshot | QueryDocumentSnapshot
) {
  if (!doc.exists()) return undefined;
  return { ...doc.data(), uid: doc.id };
}
